// pages/PostPage.tsx
import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../components/Loader';

const ViewPost = React.lazy(() => import('../components/ViewPost'));

export const PostPage = () => {
    const { postId } = useParams<{ postId: string }>();
    return (
        <Suspense fallback={<Loader />}>
            <ViewPost postId={postId || '0'} />
        </Suspense>
    );
};
